import React from 'react';

/**
 * Warm banner for children under 3 months old.
 * Encourages the guardian to record the birth story while memories are fresh.
 *
 * Props:
 *   daysOld - number of days since birth
 */
function NewbornBanner({ daysOld }) {
  const daysLabel = daysOld === 1 ? '1 day' : `${daysOld} days`;

  return (
    <div className="rounded-xl bg-[#556B2F] text-white p-5 sm:p-6 mb-6 shadow-md">
      <div className="flex items-start gap-4">
        <span className="text-3xl flex-shrink-0" role="img" aria-label="baby">
          {'\uD83D\uDC76'}
        </span>
        <div>
          <h2 className="font-serif text-xl sm:text-2xl font-bold mb-1">
            {daysLabel} of wonder
          </h2>
          <p className="text-white/90 text-base sm:text-lg leading-relaxed">
            These early moments pass so quickly. Take a few minutes to capture the birth story,
            the first days, and the little details you never want to forget.
          </p>
          <p className="mt-3 text-sm text-white/70">
            Scroll down to start with <strong>"Welcome to the World"</strong>
          </p>
        </div>
      </div>
    </div>
  );
}

export default NewbornBanner;
